import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";
import i18n from "i18n/i18next";

const { auth } = routes;

/**
 * The pre-auth area's route tree: each registry node paired with its screen. The
 * shared registration context and the org/itin query-param persistence live in
 * AuthLayout, which wraps these routes in routes.tsx.
 */
export const authRoutes: RouteRender[] = [
  lazyView(auth.signIn, () => import("./sign-in/auth-sign-in").then((m) => ({ default: m.AuthSignInPage })), "Sign In"),
  lazyView(
    auth.signInEmailSent,
    () => import("./sign-in/email-sent/auth-sign-in-email-sent").then((m) => ({ default: m.AuthSignInEmailSentPage })),
    () => i18n.t("authentication.sign-in.passwordless-email"),
  ),
  lazyView(
    auth.forgotPassword,
    () => import("./forgot-password/auth-forgot-password").then((m) => ({ default: m.AuthForgotPasswordPage })),
    () => i18n.t("authentication.forgot-password.recovery"),
  ),
  lazyView(
    auth.forgotPasswordEmailSent,
    () =>
      import("./forgot-password/email-sent/auth-forgot-password-email-sent").then((m) => ({
        default: m.AuthForgotPasswordEmailSentPage,
      })),
    () => i18n.t("authentication.forgot-password.email-sent"),
  ),
  lazyView(
    auth.signUp,
    () => import("./sign-up/auth-sign-up").then((m) => ({ default: m.AuthSignUpPage })),
    () => i18n.t("authentication.sign-up.sign-up"),
  ),
  lazyView(
    auth.signUpEmailSent,
    () => import("./sign-up/email-sent/auth-sign-up-email-sent").then((m) => ({ default: m.AuthSignUpEmailSentPage })),
    () => i18n.t("authentication.sign-up.check-inbox"),
  ),
  lazyView(
    auth.signUpDetails,
    () => import("./sign-up/details/auth-sign-up-details").then((m) => ({ default: m.AuthSignUpDetailsPage })),
    () => i18n.t("authentication.add-details.add-your-dets"),
  ),
  lazyView(
    auth.signUpPassword,
    () => import("./sign-up/password/auth-sign-up-password").then((m) => ({ default: m.AuthSignUpPasswordPage })),
    () => i18n.t("authentication.add-details.create-password"),
  ),
  lazyView(
    auth.signUpProfilePicture,
    () =>
      import("./sign-up/profile-picture/auth-sign-up-profile-picture").then((m) => ({
        default: m.AuthSignUpProfilePicturePage,
      })),
    () => i18n.t("authentication.add-details.add-profile-picture"),
  ),
  lazyView(
    auth.terms,
    () => import("./terms/auth-terms").then((m) => ({ default: m.AuthTermsPage })),
    "Terms & Policies",
  ),
  lazyView(
    auth.confirmEmail,
    () => import("./confirm-email/auth-confirm-email").then((m) => ({ default: m.AuthConfirmEmailPage })),
    () => i18n.t("authentication.sign-up.keep-eye-email"),
  ),
  lazyView(
    auth.organisation,
    () => import("./organisation/auth-organisation").then((m) => ({ default: m.AuthOrganisationPage })),
    () => i18n.t("authentication.join-team.existing-found"),
  ),
  lazyView(
    auth.organisationDetails,
    () =>
      import("./organisation/details/auth-organisation-details").then((m) => ({
        default: m.AuthOrganisationDetailsPage,
      })),
    () => i18n.t("authentication.tell-us-more-about-your-team"),
  ),
  lazyView(
    auth.teamName,
    () => import("./team-name/auth-team-name").then((m) => ({ default: m.AuthTeamNamePage })),
    "Team Name",
  ),
  lazyView(
    auth.requestAccess,
    () => import("./request-access/auth-request-access").then((m) => ({ default: m.AuthRequestAccessPage })),
    "Request Access",
  ),
  lazyView(
    auth.requestAccessEmailSent,
    () =>
      import("./request-access/email-sent/auth-request-access-email-sent").then((m) => ({
        default: m.AuthRequestAccessEmailSentPage,
      })),
    () => i18n.t("authentication.sign-up.keep-eye-email"),
  ),
  lazyView(
    auth.complete,
    () => import("./complete/auth-complete").then((m) => ({ default: m.AuthCompletePage })),
    () => i18n.t("authentication.set-up-complete.complete"),
  ),
  lazyView(
    auth.notSameUser,
    () => import("./not-same-user/auth-not-same-user").then((m) => ({ default: m.AuthNotSameUserPage })),
    "",
  ),
  lazyView(auth.joined, () => import("./joined/auth-joined").then((m) => ({ default: m.AuthJoinedPage })), ""),
  lazyView(auth.join, () => import("./join/auth-join").then((m) => ({ default: m.AuthJoinPage })), ""),
];
